const groups = {
  templates: { route: 'AdminToolTemplatesSection', sections: ['nominations', 'places', 'tournaments'], storage: 'admin-templates-active-tab' },
  players: { route: 'AdminToolPlayersSection', sections: ['list', 'labels', 'categories', 'titles'], storage: 'admin-players-active-tab' },
  accounting: { route: 'AdminToolAccountingSection', sections: ['tournaments', 'subscriptions', 'rules'], storage: 'admin-accounting-active-tab' },
};

export function adminSectionLocation(group, section, route) {
  const config = groups[group];
  return {
    name: config.route,
    params: { ...route.params, section: config.sections.includes(section) ? section : config.sections[0] },
    query: route.query || {},
    hash: route.hash,
  };
}

/** Общая ссылка открывает последний выбранный раздел. */
export function redirectAdminSection(group, route) {
  const config = groups[group];
  let section;
  try { section = localStorage.getItem(config.storage); } catch { /* Хранилище необязательно. */ }
  return adminSectionLocation(group, section, route);
}

/** URL — источник выбранного раздела. Хранилище используется только для общей ссылки. */
export function adminSectionMemory(group) {
  return {
    watch: {
      '$route.params.section': {
        immediate: true,
        handler(section) {
          const config = groups[group];
          if (this.$route.name !== config.route || !config.sections.includes(section)) return;
          try { localStorage.setItem(config.storage, section); } catch { /* Навигация продолжает работать. */ }
        },
      },
    },
  };
}
